import type { FetchModelResponse } from '@cian/http-api';

import type { TCianApiSiteV1SearchRegionsCitiesResponse } from '../../../repositories/monolith-python/cian-api/site/v1/search-regions-cities';
import type { ISearchRegionsCitiesResponseSchema33 } from '../../../repositories/monolith-python/entities/schemas/SearchRegionsCitiesResponseSchema33';
import { ResponseError } from '../../../utils/errors';

export function assertResponseError(
  response: TCianApiSiteV1SearchRegionsCitiesResponse,
): asserts response is FetchModelResponse<200, 'json', ISearchRegionsCitiesResponseSchema33> {
  if (response.statusCode === 200) {
    return;
  }

  const { message, errors } = response.response.data;

  throw new ResponseError({
    domain: 'shared/services/searchRegions/regionSuggests#assertResponseError()',
    message: 'Failed loading regions searching results',
    details: { message, errors: JSON.stringify(errors) },
  });
}
